import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Each browser tab stays pinned to the company it is showing.
let tabCompany = new URLSearchParams(window.location.search).get("c") || sessionStorage.getItem("khata_company") || "";
if (tabCompany) sessionStorage.setItem("khata_company", tabCompany);
export const getTabCompany = () => tabCompany;
export const setTabCompany = (id) => {
  tabCompany = id || "";
  if (tabCompany) sessionStorage.setItem("khata_company", tabCompany);
  else sessionStorage.removeItem("khata_company");
};
api.interceptors.request.use((cfg) => {
  if (tabCompany) cfg.headers["X-Company-Id"] = tabCompany;
  return cfg;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") {
    const s = detail.trim();
    if (/<!doctype|<html|cloudflare|origin web server|<\/?[a-z][\s\S]*>/i.test(s))
      return "Couldn't reach the server. Please check your connection and try again.";
    return s;
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  "₹" +
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const today = () => new Date().toISOString().slice(0, 10);

export const getRoles = (u) => u?.tenant_roles || (u?.tenant_role ? [u.tenant_role] : []);
export const hasWrite = (u) => getRoles(u).some((r) => r === "cashier" || r === "accountant" || r === "admin");
export const isAccountant = (u) => getRoles(u).includes("accountant");
export const isAdmin = (u) => getRoles(u).includes("admin");
export const isApprover = (u) =>
  u?.platform_role === "superadmin" || getRoles(u).includes("admin");

export const MODULES = [
  { key: "dashboard", label: "Dashboard" },
  { key: "analytics", label: "Analytics" },
  { key: "cashbook", label: "Cash Book" },
  { key: "invoices", label: "Invoices" },
  { key: "vouchers", label: "Vouchers" },
  { key: "salary", label: "Salary Ledger" },
  { key: "assets", label: "Assets" },
  { key: "credit", label: "Credit Parties" },
  { key: "parties", label: "Parties" },
  { key: "reports", label: "Reports" },
  { key: "settings", label: "Settings" },
  { key: "gatepass", label: "Gate Pass" },
  { key: "stock", label: "Stock (Inventory Hub)" },
  { key: "storeinvoices", label: "Store Invoices" },
];

const LIMITED = { gatepass: ["/gatepass"], credit: ["/credit"], storeinvoices: ["/store-invoices"] };
const limitedKeys = (u) => (!isAdmin(u) && u?.platform_role !== "superadmin" && Array.isArray(u?.module_access) && u.module_access.length > 0 && u.module_access.every((k) => LIMITED[k]) ? u.module_access : null);
export const isGatePassOnly = (u) => !!limitedKeys(u);
export const allowedPath = (u, path) => { const k = limitedKeys(u); return !k || k.some((m) => LIMITED[m].some((p) => path === p || path.startsWith(`${p}/`))); };
export const homePath = (u) => { if (u?.platform_role === "superadmin") return "/admin"; const k = limitedKeys(u); return k ? LIMITED[["gatepass", "credit", "storeinvoices"].find((m) => k.includes(m))][0] : "/dashboard"; };

export const hasModule = (u, key) => {
  if (!u) return false;
  if (u.platform_role === "superadmin" || isAdmin(u)) return true;
  if (key === "dashboard") return !isGatePassOnly(u);
  const ma = u.module_access;
  if (ma == null) return true; // no restriction set => full access
  if (key === "gatepass") return ma.includes("gatepass") || ma.includes("invoices");
  if (key === "storeinvoices") return ma.includes("storeinvoices") || ma.includes("invoices");
  return ma.includes(key);
};

export default api;
